/**
 * @generated SignedSource<<dbaf110c0fdc8002fc6ea4720ec41171>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutWireTransferForm_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ControlledAddressForm_viewer">;
  readonly " $fragmentType": "CheckoutWireTransferForm_viewer";
};
export type CheckoutWireTransferForm_viewer$key = {
  readonly " $data"?: CheckoutWireTransferForm_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutWireTransferForm_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutWireTransferForm_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ControlledAddressForm_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "0bc11d4b7817204794ce113e6b39a482";

export default node;
